export function point_center(point1, point2) {
    return {
        x: (point1.x + point2.x) / 2,
        y: (point1.y + point2.y) / 2,
    };
}
export function point_distance(point1, point2) {
    // Abstand zweier Punkte berechnen (Pythagoras)
    const seiteX = point2.x - point1.x;
    const seiteY = point2.y - point1.y;
    return Math.sqrt(Math.pow(seiteX, 2) + Math.pow(seiteY, 2));
}
